import { createPartnerMarketLeasing } from 'legacy/lut/services/partner360/marketInfo/createPartnerMarketLeasing'
import { map1018ToMarketLeasing } from 'legacy/lut/services/partner360/marketInfo/mappings/map1018ToMarketLeasing'
import { IJBPMarketLeasingCrudParams } from 'legacy/lut/services/partner360/marketInfo/models'
import { updatePartnerMarketLeasing } from 'legacy/lut/services/partner360/marketInfo/updatePartnerMarketLeasing'
import { createAsyncThunk } from 'legacy/lut/store/utils/createAsyncThunk'

import { requestRecalculateCompleteness } from '../../completeness'
import { selectFinancialYear, selectPartner360Data } from '../../configuration'
import { REQUEST_CHANGE_PARTNER_MARKET_LEASING } from '../constants'
import { IPartnerMarketLeasing } from '../models/IMarketInfo'

type TUpdateRequestParams = {
  params: IJBPMarketLeasingCrudParams
  data: IPartnerMarketLeasing
}

export const requestChangePartnerMarketLeasing = createAsyncThunk<
  IPartnerMarketLeasing,
  TUpdateRequestParams
>(REQUEST_CHANGE_PARTNER_MARKET_LEASING, async ({ params, data }, { dispatch, getState }) => {
  const configuration = selectPartner360Data(getState())
  const fYear = selectFinancialYear(getState())

  const { entryId, ...restData } = data

  const updatedItem = entryId
    ? await updatePartnerMarketLeasing(params, {
        entryId,
        ...restData,
      })
    : await createPartnerMarketLeasing(params, restData)

  await dispatch(
    requestRecalculateCompleteness({
      partnerId: configuration.partnerId,
      fYear,
    })
  )

  return map1018ToMarketLeasing(updatedItem)
})
